import Axios from "./index";
import { parseFilters } from "./helper";

export const browse = (params) => {
  return Axios.get(`/user/discover/browse`, { params: parseFilters(params) });
};

export const indexTrending = () => {
  return Axios.get(`/user/discover/trending`);
};

export const indexWhatsHot = (params) => {
  return Axios.get("/user/discover/whats_hot", {
    params: parseFilters(params),
  });
};

export const browseableKeys = {
  songs: {"includes[songs]": 6},
  artists: {"includes[artists]": 4},
  profiles: {"includes[profiles]": 4},
  albums: {"includes[albums]": 3},
  playlists: {"includes[playlists]": 3},
};
